import React from "react";

export default class InputField extends React.Component {
  static defaultProps = {
    type: "text",
    validation: false,
    placeholder: "",
    extraClass: "",
    onChange: false,
    value: false,
    lbl: "",
    muteTxt: "",
  };

  constructor(props) {
    super(props);
    this.state = { error: null, value: "" };
  }

  onChangeVal = (event) => {
    const { onChange } = this.props;
    const { value } = event.target;
    if (onChange) {
      onChange(event);
    } else {
      this.setState({ value: value });
    }
  };

  renderInput() {
    const {
      name,
      validation,
      lbl,
      placeholder,
      type,
      extraClass,
      value,
      muteTxt,
    } = this.props;
    let val = value;
    if (typeof value == "object") {
      val = value[name];
    } else if (typeof value == "string") {
      val = value;
    } else if (typeof value == "boolean") {
      const { value } = this.state;
      val = value;
    }

    return (
      <div className={`${extraClass}`}>
        <div>
          {lbl !== "" && (
            <label
              htmlFor={name}
              className="block font-medium text-gray-900 text-sm/6"
            >
              {lbl}
            </label>
          )}
          <div className="mt-2">
            <input
              id={name}
              name={name}
              type={type}
              placeholder={placeholder}
              value={val}
              onChange={this.onChangeVal}
              className={`
                block px-3.5 py-2 w-full text-base text-gray-900 bg-white outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6
                ${
                  validation && validation[name]
                    ? "border-red-500"
                    : "border-gray-300"
                }
              `}
              autoComplete="off"
              data-lpignore="true"
              data-form-type="other"
            />
          </div>
        </div>
        {muteTxt && <p className="mt-1 text-sm text-gray-500">{muteTxt}</p>}
        {validation && validation[name] && (
          <p className="mt-1 text-sm text-red-600">{validation[name]}</p>
        )}
      </div>
    );
  }

  render() {
    return this.renderInput();
  }
}
